#import "../../../../common/graphql/DocumentFileDistributionsByDocumentFileId.graphql"
query PersoanlReports(
  $first: Int
  $after: Cursor
  $orderBy: [EntityDocumentsOrderBy!]
  $filter: EntityDocumentFilter
) {
  entityDocumentPersonalPools(
    first: $first
    after: $after
    orderBy: $orderBy
    filter: $filter
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
    nodes {
      id
      fileIndexInformation
      _isProtected
      _fileViewer
      _isDocumentTextExtensionExists
      _documentTextExtension {
          extendedDescription
          isImageDescriptionExists
          isTranslatedDescriptionExists
          sourceLanguage
          translatedDescription
          alternateDescription
          isAlternateDescriptionExists
        }
      indexName
      indexDescription
      indexReferenceNumber
      indexTransactionDate
      indexCurrencyId
      documentTypeId
      entityDocumentTypeId
      entityId
      comment
      fileReference
      iconType
      isShareable
      _isDocumentTypeUpdatable
      _isAccountingDocument
      _isReportingDocument
      _uploadDate
      _sharedByUser
      _isUpdatable
      _isDeletable
      _rowTimestamp
      _fileName
      _fileType
      _createdDate
      _isDocumentShare
      indexAmount
      lookupName {
        lookupName
        id
        isApprovedVendor
        lookupCode
        lookupName
        lookupName2
        address1
        address2
        city
        state
        zipCode
        country
        phone
        emailAccount
      }
      ...DocumentFileDistributionsByDocumentFileId
      currency {
        isoCode
      }
      documentAppliedAmounts {
        id
        appliedTotal
        overageTotal
        retiredTotal
        usedTotal
        remainingTotal
        _isRemainingAmountAvailable
        _isRetiringBalanceAllowed
      }
      documentTypes {
        id
        documentType
        isAccountingDocument
        isSigningRequired
        _isAppliableDocumentType
        _isPoSystemDocument
      }
      _documentContents
      extractionTypeId
      extractionType {
        isExtractProtected
      }
    }
  }
}
